<template>
    <div>
        <div class="myshadow" v-show="tipStatus" v-on:click="toCancel"></div>
        <div class="myalertBox rel" v-show="tipStatus">
            <div class="flexBox myborderB">
                <div class="myalertBottomBtn"
                     :class="{'color_use':styleName === 'main' && tabIndex === 0,'color_red':styleName === 'main_b' && tabIndex === 0,'color_green':styleName === 'main_c' && tabIndex === 0}"
                     v-on:click='typeTab(0)'>短链接
                </div>
                <div class="myalertBottomBtn"
                     :class="{'color_use':styleName === 'main' && tabIndex === 1,'color_red': styleName === 'main_b' && tabIndex === 1,'color_green':styleName === 'main_c' && tabIndex === 1}"
                     v-on:click='typeTab(1)'>淘口令
                </div>
            </div>
            <div class="ml10 mr10 mt15" v-show="tabIndex === 0">
                <input type="text"
                       class="enrollFormInput"
                       v-model="shopDetail.short_url" />
            </div>
            <div class="ml10 mr10 mt15" v-show="tabIndex === 1">
                <input type="text"
                       class="enrollFormInput"
                       v-model="shopDetail.tpwd" />
            </div>
            <div class="myalertBottom flexBox">
                <div class="myalertBottomBtn" v-on:click="toCancel">取消</div>
                <div class="myalertBottomBtn myalertBottomBtnBL" id="copy_link"
                     :data-clipboard-text="shopDetail.short_url" v-show="tabIndex === 0"
                     :class="{'color_use':styleName === 'main','color_red':styleName === 'main_b','color_green':styleName === 'main_c'}"
                     v-on:click="copy('#copy_link')">复制短链接
                </div>
                <div class="myalertBottomBtn myalertBottomBtnBL" id="copy_tpwd"
                     :data-clipboard-text="shopDetail.tpwd" v-show="tabIndex === 1"
                     :class="{'color_use':styleName === 'main','color_red':styleName === 'main_b','color_green':styleName === 'main_c'}"
                     v-on:click="copy('#copy_tpwd')">复制淘口令
                </div>
            </div>
        </div>
        <header class="Mybar bg_white">
            <div class="mybarLeft" v-on:click="toPrev"><span
                    class="iconfont icon-zuojiantou f12 color_999"></span></div>
            <div class="myTitle">店铺详情</div>
            <div class="mybarRight f8 color_999" v-on:click="getLink()">店铺推广链接</div>
        </header>
        <main class="MainCon bottom0">
            <div class="ml7 mr7 mt12">
                <div class="myContentBox pt10 pb10">
                    <p class="tc" style="line-height: 72px;">
                        <img v-bind:src="shopDetail.shop_icon"
                             @load="autoResizeImage(0,72,$event)" />
                    </p>
                    <p class="shopName f10 mt5">{{shopDetail.shop_name}}</p>
                    <p class="tc mt5"><span
                            class="shopAddress">信用：{{shopDetail.credit}}&nbsp;&nbsp;地址：{{shopDetail.address}}</span>
                    </p>
                    <p class="tc f8 mt5 color_999 lh20">30天总推广量：{{shopDetail.total_volume}}&nbsp;&nbsp;|&nbsp;&nbsp;30天支付总佣金：{{shopDetail.commission_amount_30d}}</p>
                    <div class="ml7 mr7">
                        <div class="indexMenuBox">
                            <div class="flexBox-cell-33 lh24 f8"
                                 v-for='(evaluates,index) in shopDetail.evaluates' :key="index">
                                <span v-html="evaluates.title"></span>:
                                <span v-html="evaluates.score"></span>
                                <span
                                        :class="{'scoreBlock':styleName === 'main','scoreBlock_red':styleName === 'main_b','scoreBlock_green':styleName === 'main_c'}"
                                        v-html="evaluates.levelText"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="myContentBox pt5 pb10 mt10" v-if="couponList.length > 0">
                    <div class="ml7 mr7">
                        <p class="f10 b lh24">店铺优惠券</p>
                        <div class="flexBox flexBetween mt5">
                            <div class="flexBox-cell-48 rel" v-for="(item,index) in couponList"
                                 v-on:click="toGoodsCoupon(item.coupon_url)" :key="index">
                                <div :class="{'shopCouponBtn':styleName === 'main','shopCouponBtn_red':styleName === 'main_b','shopCouponBtn_green':styleName === 'main_c'}">
                                    <div class="mt7">立<br>即<br>领<br>取</div>
                                </div>
                                <div class="shopCouponBox">
                                    <p class="f8 lh16 ml5"
                                       :class="{'color_use':styleName === 'main','color_red':styleName === 'main_b','color_green':styleName === 'main_c'}">￥<em
                                            class="f12">{{item.coupon_discount}}</em></p>
                                    <p class="f8 lh16 ml5"
                                       :class="{'color_use':styleName === 'main','color_red':styleName === 'main_b','color_green':styleName === 'main_c'}">{{item.coupon_reach_text}}</p>
                                    <p class="f8 lh16 ml5">{{item.type_text}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="goodsList.length > 0">
                    <p class="f14 b tc lh32 rel mt10">
                        所有商品
                        <span class="titleLeftImg"><img src="@/assets/images/titleLeft.png"></span>
                        <span class="titleRightImg"><img
                                src="@/assets/images/titleRight.png"></span>
                    </p>
                    <p class="f8 tc color_999">精选推荐 好物抢购</p>

                    <div class="ml5 mr5 mt10 mb10">
                        <div class="goodInfoBoxList flexBetween">
                            <div class="indexGoodBlock mb5 flexBox-cell-48"
                                 v-for="(item,index) in goodsList"
                                 :key="index">
                                <GoodsListItem :style-name="styleName" :goods-data="item" />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </main>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import {showTip} from '../../libs/utils';
    import GoodsListItem from './TopGoodsListItem';
    import {mapState} from 'vuex';

    export default {
        components: {GoodsListItem},
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            shopDetail: {
                type: Object,
                default() {
                    return {
                        shop_icon: '',
                        shop_name: '',
                        credit: '',
                        address: '',
                        total_volume: '',
                        commission_amount_30d: '',
                        evaluates: [],
                        short_url: '',
                        tpwd: ''
                    }
                }
            },
            couponList: {
                type: Array
            },
            goodsList: {
                type: Array
            },
        },
        data() {
            return {
                tipStatus: false,
                tabIndex: 0,
            }
        },
        computed: {
            ...mapState(['app'])
        },
        methods: {
            autoResizeImage: (maxWidth, maxHeight, event) => {
                let thisImg = event.currentTarget;
                let img = new Image();
                img.src = thisImg.src;
                let hRatio;
                let wRatio;
                let Ratio = 1;
                let w = img.width;
                let h = img.height;
                wRatio = maxWidth / w;
                hRatio = maxHeight / h;
                if (maxWidth === 0 && maxHeight === 0) {
                    Ratio = 1;
                } else if (maxWidth === 0) {//
                    if (hRatio < 1) Ratio = hRatio;
                } else if (maxHeight === 0) {
                    if (wRatio < 1) Ratio = wRatio;
                } else if (wRatio < 1 || hRatio < 1) {
                    Ratio = (wRatio <= hRatio ? wRatio : hRatio);
                }
                if (Ratio < 1) {
                    w = w * Ratio;
                    h = h * Ratio;
                }
                thisImg.height = h;
                thisImg.width = w;
            },
            toGoodsDetail: (id) => {
                const route = {
                    name: 'top-goods-detail',
                    query: {
                        id
                    }
                };
                this.$router.push(route);
            },
            toGoodsCoupon: (url) => {
                window.location.href = url;
            },
            getLink: function () {
                this.tipStatus = true;
            },
            copy: function (id) {
                let clipboard = new Clipboard(id);

                clipboard.on('success', () => {
                    showTip('复制成功');
                    clipboard.destroy()
                })
                clipboard.on('error', () => {
                    showTip('该浏览器不支持自动复制');
                    clipboard.destroy()
                })
            },
            typeTab: function (index) {
                this.tabIndex = index;
            },
            toCancel: function () {
                this.tipStatus = false;
            },
            toPrev: function () {
                if (this.app.history.length <= 1) {
                    this.$router.push('/')
                } else {
                    this.$router.back();
                }
            },
        }
    }
</script>

<style scoped>

</style>
